export const oneriSarkiTranslations = {
    "Öneri Şarkı Yönetim": { en: "xxxxxxxxx" },
    "Şarkı Önerisi siliniyor": { en: "xxxxxxxxx" },
    "Şarkı Önerisi güncelleniyor": { en: "xxxxxxxxx" },
    "Kullanıcının Şarkı Önerileri getiriliyor": { en: "xxxxxxxxx" },
    "Şarkı Önerileri getiriliyor": { en: "xxxxxxxxx" },
    "Şarkı Önerisi yorumlanıyor": { en: "xxxxxxxxx" },
    "Şarkı Önerisi ekleniyor": { en: "xxxxxxxxx" },
}
